import { redirect } from '@tanstack/react-router';
import { FEATURE_FLAGS } from '@vizit/constants';
import { getFeatureFlag } from '@vizit/feature-flags';

/**
 * Keeps benchmark pages unreachable while custom benchmarks are off, even by a pasted URL: sends the user to the
 * Library's Collections view instead, the place benchmarks are listed when the flag is on.
 */
export async function guardCustomBenchmarks(workspaceSlug: string) {
  const isEnabled = await getFeatureFlag(FEATURE_FLAGS.CUSTOM_BENCHMARKS_FE, false);

  if (!isEnabled) {
    throw redirect({
      to: '/w/$workspaceSlug/library/',
      params: { workspaceSlug },
      search: { view: 'collections' },
      replace: true,
    });
  }
}
